import React, { Component } from "react";
import ReactDOM from "react-dom";

import promoImage from "../../images/popup_album/second-song-popup.png";


const PROMO_ROUTE =
  "/news/on-new-album-second-song-neil-young-meditates-on-the-passage-of-time/";

const PROMO_ALT =
  "Neil Young & The Chrome Hearts — Second Song. New studio album: listen & get it now";

export default class AlbumPromoPopup extends Component {
  constructor(props) {
    super(props);


    this.state = { visible: true };

    this.close = this.close.bind(this);
    this.goToArticle = this.goToArticle.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onImageError = this.onImageError.bind(this);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.onKeyDown, false);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown, false);
  }

  onKeyDown(e) {
    if (e.key === "Escape" || e.keyCode === 27) this.close();
  }


  onImageError() {
    this.setState({ visible: false });
  }

  close(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!this.state.visible) return;
    this.setState({ visible: false });
  }

  goToArticle(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ visible: false });

    const { history } = this.props;
    if (history) {
      history.push(PROMO_ROUTE);
    } else {
      window.location.href = PROMO_ROUTE;
    }
  }

  render() {
    if (!this.state.visible) return null;

    return ReactDOM.createPortal(
      <div className="album-promo-overlay" onClick={this.close}>
        <div className="album-promo-panel">
          <a
            href={PROMO_ROUTE}
            className="album-promo-link"
            onClick={this.goToArticle}
          >
            <img
              className="album-promo-img"
              src={promoImage}
              alt={PROMO_ALT}
              onError={this.onImageError}
            />
          </a>
        </div>
      </div>,
      document.body
    );
  }
}
